import axios from "axios";
import { getToken } from "../utils/auth";

// API Base URL from environment variable
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:1111";

const FormDataApiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
  timeout: 30000, // 30 seconds
});

// Note: Interceptors are now set up in useAxiosInterceptor hook
// This allows us to use React Router's navigate function
// The hook is used in App.js

FormDataApiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default FormDataApiClient;
